import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

class Modals {
  constructor() {
    this.modals = document.querySelectorAll('.c-modal')
    if (!this.modals.length) return
    this.init()
  }

  init() {
    this.modals.forEach((modal) => {
      let state = false

      const id = modal.getAttribute('id')
      const triggers = document.querySelectorAll(`[data-modal="${id}"]`)
      const wrapper = modal.querySelector('.c-modal__wrapper')

      const timeline = gsap.timeline(
        {
          yoyo: true,
          paused: true,
        },
      )
        .set(modal, {
          display: 'block',
        })
        .set(wrapper, {
          autoAlpha: 0,
        })
        .fromTo(modal, {
          opacity: 0,
        }, {
          duration: 0.6,
          opacity: 1,
          ease: 'power2.inOut',
        })
        .fromTo(wrapper, {
          autoAlpha: 0,
          y: 50,
        }, {
          duration: 0.5,
          autoAlpha: 1,
          y: 0,
          ease: 'power2.inOut',
        }, '-=0.35')

      triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          state = !state
          // modal.classList.toggle('--active', state)
          document.body.classList.toggle('has-modal', state)
          document.body.classList.toggle(`has-modal-${id}`, state)

          if (state) {
            timeline.timeScale(1)
            timeline.play()
          } else {
            timeline.timeScale(2)
            timeline.reverse()
          }
        })
      })
    })
  }
}

export default Modals
